'use client';

import { useTheme } from 'next-themes';
import { useEffect, useState } from 'react';
import { Moon, Sun } from 'lucide-react';
import { Button } from '@/shared/components/ui/button';

export function ThemeToggle() {
  const { theme, setTheme, resolvedTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  // Avoid hydration mismatch
  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return (
      <Button variant="ghost" size="icon" className="h-9 w-9 landscape:h-7 landscape:w-7">
        <span className="sr-only">Toggle theme</span>
      </Button>
    );
  }

  const isDark = resolvedTheme === 'dark';

  return (
    <Button
      data-testid="theme-toggle-button"
      variant="ghost"
      size="icon"
      className="h-9 w-9 landscape:h-7 landscape:w-7"
      onClick={() => setTheme(isDark ? 'light' : 'dark')}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {isDark ? (
        <Sun className="h-5 w-5 landscape:h-4 landscape:w-4 text-warning" />
      ) : (
        <Moon className="h-5 w-5 landscape:h-4 landscape:w-4 text-muted-foreground" />
      )}
    </Button>
  );
}
